export enum UserAppState {
  REWARD_ONLY = "REWARD_ONLY",
  PAYMENT_ONLY = "PAYMENT_ONLY",
  UNIFIED = "UNIFIED",
}
